import { ServiceBundle } from '../../../../../models/service-bundle';
import { SaveServiceBundleForm } from './save-service-bundle.form';

interface CreateServiceBundleFormProps {
  officeID: number;
  onCompleted: (value: ServiceBundle) => void;
  refetch: () => void;
}

export const CreateServiceBundleForm = ({ officeID, onCompleted, refetch }: CreateServiceBundleFormProps) => {
  return <SaveServiceBundleForm officeID={officeID} onCompleted={onCompleted} refetch={refetch} />;
};
